import React, { useState } from 'react';
import {
    Dialog,
    Box,
    Typography,
    Button,
    IconButton,
    OutlinedInput,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import get from "lodash/get";
import map from "lodash/map";
import trim from "lodash/trim";
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from "react-redux";

import Table from "../../../components/form/Table";
import Question from '../../../components/form/Question';

import { getTransport } from "../../../store/masters/thunk/transport/getAll";

const TransportModal = ({
    __,
    open,
    close,
    callback,
    division,
    tonnelage
}) => {
    const [searchValue, setSearchValue] = useState("");
    const [openQuestion, setOpenQuestion] = useState({
        value: "",
        state: false
    });
    const [selected, setSelected] = useState({})
    const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })

    const onChange = (e) => {
        setSearchValue(trim(e.target.value))
    }

    const transportAll = useSelector(state => state.masters.transport); 
    
    const onAdd = () => {
        (get(selected, "name"))
        setSelected({})
        callback(openQuestion.value)
        setOpenQuestion(prev => ({ ...prev, state: false}))
      }
    
    const headTable = [
        {
            key: "Button",
            label: "Seleccionado",
            align: "center",
            width: 70,
        },
        {
            key: "comercialName",
            label: __(`table.colsTransport.provider`),
            align: "center",
        },
        {
            key: "name",
            label: __(`table.colsTransport.name`),
            align: "center"
        },
        {
            key: "numberPlate",
            label: __(`table.colsTransport.numberPlate`),
            align: "center"
        },
        {
            key: "transportType",
            label: __(`table.colsTransport.transportType`),
            align: "center"
        },
        {
            key: "division",
            label: __(`table.colsTransport.division`),
            align: "center"
        },
        {
            key: "temperature",
            label: __(`table.colsTransport.temperature`),
            align: "center"
        }
    ]

    const dataTable = map(get(transportAll, "data.data", []), (row, i) => {
        const labelId = `enhanced-table-checkbox-${i}`;
        return ({
            ...row,
            Button: (
                <Button
                name="btnDriver"  
                onClick={() => { setOpenQuestion(prev => ({ ...prev, state: true, value: row }))}}
                inputProps={{ 'aria-labelledby': labelId }}
                variant="contained"  
                color="primary"
                >
                Agregar
                </Button>
            ),
        })
      })

    
    return (
        <Dialog close={close} open={open} maxWidth="lg" fullWidth>
                <Box>
                    <IconButton
                        aria-label="close"
                        onClick={close}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Box className='px-6'>
                    <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                        {__(`labels.13`)}
                    </Typography>
                </Box>
                <Box className='flex flex-col justify-center m-6'>
                    {/* <div className='px-8 pyt-2'>
                        <OutlinedInput
                            id="search-btn"
                            endAdornment={
                                <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                                    <SearchIcon />
                                </IconButton>
                            }
                            aria-describedby="outlined-weight-helper-text"
                            inputProps={{
                                'aria-label': 'weight',
                            }}
                            size="small"
                            fullWidth
                            onChange={onChange}
                            placeholder={__("action.search")}
                        />
                    </div>     */}
                    <div className='px-8 pyt-2 pt-3'>
                        <Table headTable={headTable}
                            dataTable={dataTable}
                            __={__}
                            sizeFilters={125}
                            empty="transports"
                        />
                    </div>
                    <Question
                        title={__("alert.addTransport")}
                        detail={__("alert.addTansportDetail")}
                        onSuccess={onAdd}
                        onCancel={() => setOpenQuestion(prev => ({ ...prev, state: false}))}
                        open={openQuestion.state}
                    />
                </Box>
            </Dialog>
    );
}

export default TransportModal